<script setup lang="ts">
import MainContainer from '../Main/Container.vue';
import MainRoot from '../Main/Root.vue';

const props = defineProps<{
	app: 'auth' | 'camPortal';
}>();
</script>

<template>
	<div class="layout-authentication">
		<MainContainer>
			<MainRoot>
				<div class="authentication-container">
					<slot />

					<HmCopyright :app="props.app" is-absolute />
				</div>
			</MainRoot>
		</MainContainer>
	</div>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.authentication-container
	{
		@include flex;
		flex-direction:column;
		min-height:100vh;
		padding-block-end:var(--spacing-5xl);
		overflow:hidden;

		@include responsive(md)
		{
			justify-content:center;
			padding-block-start:var(--spacing-lg);
		}
	}
}
</style>
